import { action, orchestrator } from 'satcheljs';
import ActionState from 'owa-groups-shared-store/lib/schema/ActionState';
import getGroupDetailsAction from './getGroupDetailsAction';
import getGroupMembersAction from './getGroupMembersAction';
import setJoinButtonState from 'owa-groups-shared-store/lib/mutators/setJoinButtonState';
import setFollowButtonState from 'owa-groups-shared-store/lib/mutators/setFollowButtonState';
import { getJoinButtonState } from 'owa-groups-shared-store/lib/selectors/getJoinButtonState';
import { getFollowButtonState } from 'owa-groups-shared-store/lib/selectors/getFollowButtonState';

export const loadGroupInformation = action(
    'loadGroupInformation',
    (
        groupSmtpAddress: string,
        loadFullDetails?: boolean,
        membersToReturn?: number,
        onLoadGroupSuccess?: () => void,
        onLoadGroupError?: () => void
    ) => ({
        groupSmtpAddress,
        membersToReturn,
        loadFullDetails,
        onLoadGroupSuccess,
        onLoadGroupError,
    })
);

orchestrator(loadGroupInformation, actionMessage => {
    const {
        groupSmtpAddress,
        loadFullDetails,
        membersToReturn,
        onLoadGroupSuccess,
        onLoadGroupError,
    } = actionMessage;

    getGroupDetailsAction(groupSmtpAddress, loadFullDetails, onLoadGroupSuccess, onLoadGroupError);
    getGroupMembersAction(groupSmtpAddress, membersToReturn);

    // Reset button states if there isn't an on-going action.
    // We want to start from a clean slate for the buttons,unless the user
    // is already aware of what's currently going on.
    if (getJoinButtonState(groupSmtpAddress) !== ActionState.Executing) {
        setJoinButtonState(groupSmtpAddress, ActionState.None);
    }

    if (getFollowButtonState(groupSmtpAddress) !== ActionState.Executing) {
        setFollowButtonState(groupSmtpAddress, ActionState.None);
    }
});
